export const getPathList = (indices, currentId, level = 1) => {
    if (!indices) return [];
    const pathList = [];
    const hasNode = (node, targetId) => {
        if (!node) return false;
        if (node.id === targetId) return true;
        if (node.nodes) {
            return node.nodes.some(child => hasNode(child, targetId));
        }
        return false;
    };
    const traverse = (nodes) => {
        if (!nodes) return false;
        for (const node of nodes) {
            const isOpen = (node.id === currentId) || hasNode(node, currentId);
            if (isOpen) {
                traverse(node.nodes);
                if (node.Level > level) {
                    pathList.push(node);
                }
                return true;
            }
        }
        return false;
    };
    traverse(indices);
    return [...pathList].reverse();
};

export const getIndexNode = (nodes, indexId) => {
    if (!nodes || !indexId) return null;
    for (const node of nodes) {
        if (node.id === indexId) return node;
        if (node.nodes) {
            const found = getIndexNode(node.nodes, indexId);
            if (found) return found;
        }
    }
    return null;
};

export const getLessonEditUrl = (indices, lesson) => {
    if (!lesson) return "";
    const node = getIndexNode(indices?.nodes, lesson.Index?.Id);
    const type = node ? node.indexType : "";

    if (type === "Exams") {
        return `/ControlPanel/Exams/Edit/${lesson.Id}`;
    } else if (type === "Quizzes") {
        return `/ControlPanel/Quizzes/Edit/${lesson.Id}`;
    } else if (type === "Books") {
        return `/ControlPanel/Books/Edit/${lesson.Id}`;
    } else if (type === "SelfDevelopment") {
        return `/ControlPanel/SelfDevelopment/${lesson.Id}`;
    } else if (type === "Fun") {
        return `/ControlPanel/Games/Edit/${lesson.Id}`;
    } else {
        return `/ControlPanel/Lesson/Edit/${lesson.Id}`;
    }
};

export const getIndexListUrl = (indices, indexId) => {
    const node = getIndexNode(indices?.nodes, indexId);
    const type = node ? node.indexType : "";

    if (type === "Exams") {
        return `/Tracks/Exams/${indexId}`;
    } else if (type === "Quizzes") {
        return `/Tracks/Quizzes/${indexId}`;
    } else if (type === "Books") {
        return `/Tracks/BookLessons/${indexId}`;
    } else if (type === "Fun") {
        return `/Games/${indexId}`;
    } else if (type === "SelfDevelopment") {
        return `/SelfDevelopment/${indexId}`;
    } else {
        return `/Tracks/Lessons/${indexId}`;
    }
};
